import React from 'react';


import './portfolioItem.css'

import LightSpeed from 'react-reveal/LightSpeed';

function PortfolioItem(props) {
    return (
      <div className={props.offset ? "portfolio--item" : "portfolio--item--offset"  }>
        <div className={props.offset ? "background--offset" : "background--offset--offset"}>

        </div>
        <div className="portfolio--details">
            <div className="portfolio--item--title">
                {props.title}
            </div>
            <div className="portfolio--item--description">
                {props.description}
            </div>
            <div className="link--container">
                {props.link ?  <a href={props.link} className="portfolio--item--link" > Visit</a> : props.altText}
                
            </div>
        </div>
        <div className="portfolio--image--container">
           {props.offset ? 
            <LightSpeed right>
             <img src={props.thumbnail} className="portfolio--image" alt="portfilio--snippet"/>
            </LightSpeed>
            :
            <LightSpeed left>
            <img src={props.thumbnail} className="portfolio--image" alt="portfilio--snippet"/>
           </LightSpeed>
            }
        </div>

      </div>
    )
  }
  
export default PortfolioItem;
  